import Headroom from 'headroom.js';

window.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.site-header')) return;
  const navBar = document.querySelector('.site-header');
  const headroom = new Headroom(navBar);
  headroom.init();
});

document.addEventListener('click', ({ target }) => {
  if (!target.matches('.hamburger')) return;
  document.body.classList.toggle('menu-is-open');
  target.classList.toggle('hamburger--active');
  document.querySelector('.site-header').classList.toggle('site-header--active');
});

document.addEventListener('click', (e) => {
  if (!e.target.matches('.menu-item-has-children > a')) return;
  e.preventDefault();
  e.target.parentElement.classList.toggle('menu-item-has-children--active');
  e.target.parentElement.querySelector('.sub-menu').classList.toggle('sub-menu--active');
});

document.addEventListener('click', ({ target }) => {
  if (!target.matches('.site-header__search-btn')) return;
  document.body.classList.add('menu-is-open');
  document.querySelector('.header-search').classList.add('header-search--active');
});

document.addEventListener('click', ({ target }) => {
  if (!target.matches('.header-search__close')) return;
  document.body.classList.remove('menu-is-open');
  document.querySelector('.header-search').classList.remove('header-search--active');
});
